/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creating_Ad_Template_WaitInputs */



/**
* | output |
* | --- |
* | "Creating AD template... please wait..." |
*
* @param {Creating_Ad_Template_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creating_ad_template_wait = /** @type {((inputs?: Creating_Ad_Template_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creating_Ad_Template_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du modèle AD... veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Vorlage wird erstellt... Bitte warten...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione del modello di annuncio... attendere prego...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание шаблона объявления... пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando plantilla de AD... por favor espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在创建广告模板……请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AD テンプレートを作成しています...お待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD टेम्प्लेट बनाया जा रहा है... कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando modelo de anúncio... aguarde...")
	return /** @type {LocalizedString} */ ("Creating AD template... please wait...")
});